import _asyncToGenerator from "/Users/andrewgallagher/Documents/eth/highrises/static-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/Users/andrewgallagher/Documents/eth/highrises/static-site/node_modules/@babel/runtime/regenerator/index.js";
import { createContext, useContext } from 'react';
import { ChainId } from '../../../constants';
export var NetworkContext = createContext({
  network: {
    provider: undefined,
    chainId: ChainId.Mainnet,
    accounts: [],
    errors: []
  },
  update: function update() {
    return undefined;
  },
  reportError: function reportError() {
    return undefined;
  },
  activate: function () {
    var _activate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", undefined);

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function activate() {
      return _activate.apply(this, arguments);
    }

    return activate;
  }(),
  deactivate: function deactivate() {
    return undefined;
  },
  activateBrowserWallet: function activateBrowserWallet() {
    return undefined;
  },
  isLoading: true
});
/**
 * @internal
 */

export function useNetwork() {
  return useContext(NetworkContext);
}